import { Checkbox } from "components/Checkbox";
import { ModalContentWrapper } from "components/ModalContentWrapper";
import { FC } from "react";
import { Control, FieldErrors, UseFormRegister } from "react-hook-form";
import { OperatorPrivileges } from "types/company.type";

interface Props {
  register: UseFormRegister<OperatorPrivileges>;
  errors: FieldErrors<OperatorPrivileges>;
  control?: Control<OperatorPrivileges>;
}

export const EditOperatorRightsModal: FC<Props> = ({
  register,
  errors,
  control,
}) => {
  return (
    <ModalContentWrapper>
      {control && (
        <>
          <Checkbox
            label="Visa kundlista"
            name="viewCustomerList"
            control={control}
          />
          <Checkbox
            label="Lägg till kund"
            name="addCustomer"
            control={control}
          />
          <Checkbox label="Visa kund" name="viewCustomer" control={control} />
          <Checkbox
            label="Redigera kund"
            name="editCustomer"
            control={control}
          />
          <Checkbox
            label="Lägg till anläggning"
            name="addFacility"
            control={control}
          />
          {/* <Checkbox
            label="Visa anläggning"
            name="viewFacility"
            control={control}
          /> */}
          <Checkbox
            label="Redigera anläggning"
            name="editFacility"
            control={control}
          />
          <Checkbox
            label="Lägg till objekt"
            name="addSeparator"
            control={control}
          />
        </>
      )}
    </ModalContentWrapper>
  );
};
